import * as React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  CheckboxGroupInput,
  FormDataConsumer,
  useNotify,
} from 'react-admin'
import {
  NOT_RECURRING,
  RECURRING_CHOICES,
  WEEKDAY_CHOICES,
  WEEKLY,
  formatDay,
  isRecurring,
  recurringErrorMessage,
  seriesLimit,
  transformEventCreate,
  validateSeries,
  weekdayOf,
} from './recurringSeries'

// Einddatum en weekdagen alleen bij herhalen; elk in een eigen
// FormDataConsumer zodat SimpleForm ze als aparte rij rendert.
const EndDateInput = ({ formData, ...rest }) => {
  if (!isRecurring(formData.recurring)) return null
  const maxEndDate = seriesLimit(formData.startDate)
  return (
    <DateInput
      {...rest}
      label="Einddatum reeks"
      source="endDate"
      required
      inputProps={maxEndDate ? { max: maxEndDate } : {}}
      helperText={
        maxEndDate
          ? `Maximaal 3 maanden: uiterlijk ${formatDay(maxEndDate)}`
          : 'Maximaal 3 maanden na de startdatum'
      }
    />
  )
}

const WeekdaysInput = ({ formData, ...rest }) => {
  if (formData.recurring !== WEEKLY) return null
  const startWeekday = weekdayOf(formData.startDate)
  return (
    <CheckboxGroupInput
      {...rest}
      label="Weekdagen (optioneel)"
      source="recurringWeekdays"
      choices={WEEKDAY_CHOICES}
      helperText={
        startWeekday
          ? `De weekdag van de startdatum (${
              WEEKDAY_CHOICES[startWeekday - 1].name
            }) zit er altijd bij`
          : 'Leeg = elke week op de weekdag van de startdatum'
      }
    />
  )
}

export const EventCreate = (props) => {
  const notify = useNotify()
  const onFailure = (error) => notify(recurringErrorMessage(error), 'warning')
  return (
    <Create {...props} transform={transformEventCreate} onFailure={onFailure}>
      <SimpleForm validate={validateSeries}>
        <TextInput label="Naam" source="name" required />
        <TextInput
          multiline
          label="Beschrijving"
          source="description"
          required
        />
        <TextInput label="Prijs" source="cost" />
        <TextInput label="Fee" source="fee" disabled defaultValue={'0.50'} />
        <BooleanInput
          label="Alleen betalen met strippenkaart"
          source="creditcardOnly"
        />
        <DateInput label="Datum" source="startDate" required />
        <TextInput label="Starttijd" source="startTime" required />
        <TextInput label="Eindtijd" source="endTime" required />
        <SelectInput
          label="Terugkerende activiteit"
          source="recurring"
          defaultValue={NOT_RECURRING}
          choices={RECURRING_CHOICES}
        />
        <FormDataConsumer>
          {(formDataProps) => <EndDateInput {...formDataProps} />}
        </FormDataConsumer>
        <FormDataConsumer>
          {(formDataProps) => <WeekdaysInput {...formDataProps} />}
        </FormDataConsumer>
        <NumberInput
          label="Maximaal aantal deelnemers"
          source="maximumParticipants"
          required
        />
        <BooleanInput label="Prive" source="private" />
        <NumberInput label="Locatie" source="locationID" required />
        <NumberInput label="Organisator" source="ownerID" required />
        <NumberInput
          label="Activiteit type"
          source="activity_type_id"
          required
        />
        <ReferenceInput
          required
          label="Type"
          source="event_typeID"
          reference="event_type">
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>
        <NumberInput label="Groep" source="groupID" />
      </SimpleForm>
    </Create>
  )
}
